function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => React.createElement("svg", _extends({
  viewBox: "0 0 22 22"
}, props), React.createElement("g", {
  fill: "currentColor"
}, React.createElement("path", {
  d: "M11 21.65C5.118 21.65.35 16.882.35 11 .35 5.118 5.118.35 11 .35 16.882.35 21.65 5.118 21.65 11c0 5.882-4.768 10.65-10.65 10.65zm0-3.3a7.35 7.35 0 100-14.7 7.35 7.35 0 000 14.7z"
}), React.createElement("path", {
  d: "M5.697 18.637l12.94-12.94-2.334-2.334-12.94 12.94z"
}))));